import React, { Component } from "react";
import { Box, HStack, Text, Spacer, Square } from '@chakra-ui/react';
import zoomPlugin from 'chartjs-plugin-zoom';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faArrowCircleDown, faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../services/CoreService.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
  );

  function toChartData(titleText, apiData) 
  {
    const chartOptions = 
    {
      plugins: {
        title: {
          display: true,
          text: titleText,
        },
        legend: {
          display: false,
          position: "right",
        }, 
        zoom: {
          pan: {
            enabled: true,
            mode: 'x',
          },
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true
            },
            mode: 'x',
          }
        }
      },
      responsive: true
    };

    const chartLabels = (apiData) ? apiData.map((rec) => {
      return rec.label;
    }) : [];
    const chartData = (apiData) ? apiData.map((rec) => {
      return {data: rec.count};
    }) : [];
    //var result = { labels: labels, data: data };
    return {options: chartOptions, data: {labels: chartLabels, datasets: chartData}};
  }

export default class EnterpriseInboundQueueCountBarChart extends Component 
{
  constructor(props) {
    super(props);
    this.state = {
      chartOptions: [],
      chartLabels: ["Loading..."],
      chartData: null,
      isLoading: true,
      moreCaret: "caret-up",
      isCollapsed: false,
    };

    this.coreService = new CoreService();

    this.refreshData = this.refreshData.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  async componentDidMount() {
      await this.refreshData();
  }



  async refreshData() 
  {
    this.setState({ isLoading: true });
    try
    {
        var apiResult = await this.coreService.fetchInboundQueueLineCountByLocation(this.props.userSession.gcid, this.props.userSession.token);
        if (apiResult.hasError)
        {
            // TBD: we should show this in the chart box
            return;
        }
        var conformedData = toChartData("Inbound Count By Location", apiResult.dataResult);
        this.setState({
        chartOptions: conformedData.options,
        chartData: conformedData.data
        });
    }
    finally 
    {
        this.setState({isLoading: false});
    }
  }

  toggleCollapse() 
  {
    let newIsCollapsed = !this.state.isCollapsed;
    let newCaretState = newIsCollapsed ? "caret-down" : "caret-up";
    this.setState({
      isCollapsed: newIsCollapsed,
      moreCaret: newCaretState,
    });
  }


  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );


    return (
      <Box p='4' alignItems='center'>
        <HStack>
          <Spacer/>
          <Text fontSize={{ base: '16px', md: '20px', lg: '28x' }} color='white'>{(this.props.title) ? this.props.title : "Inbound Queue Count"}</Text>

          <Spacer />
          <FontAwesomeIcon icon={(this.state.isCollapsed) ? faArrowCircleDown : faArrowCircleUp} color="white" onClick={() => this.toggleCollapse()} />
          {loadingIcon}
        </HStack>
          {!this.state.isCollapsed ? (

              <Square >
                {(this.state.chartData) ?
                   <Bar
                        data={this.state.chartData}
                        options={this.state.chartOptions}
                        height="100%"
                    />
                    : <Text>Loading...</Text>
                }
          
              </Square>

          ) : (
            <span />
          )}

      </Box>
    );
  }
}



